<template lang="pug">

.t-loader
  v-progress-circular(
    indeterminate
    color="primary"
  )

</template>

<script>
import Vue from 'vue'

export default Vue.component('t-loader', {
  name: 'loading',

  props: {

  },

  data() {
    return {

    }
  },

  computed: {

  },

  methods: {

  }
})

</script>

<style lang="sass" scoped>

.t-loader
  display: flex
  align-items: center
  justify-content: center

</style>